export const KEYS = {
	BOOKING: 'booking',
	BOOKINGS: 'bookings',
};
